module.exports = __webpack_public_path__ + "img/93964.86e04f10.svg";